
import * as _ from 'lodash'
import { Injectable } from '@angular/core';
import { WorkflowsService } from '../workflows/workflows.service';
import { LWUIRuleEngine } from './lw-ui-rule-engine';
@Injectable({
  providedIn: 'root'
})
export class LWEventsExecutor{
     /**This class is responsible for executing ui_rules based on sent event name and
       perform actions based on filtered workflow 
     * @event {[type - string]}
     * @params {[type - object] - params will have issue detail and brand detail required for ui rule execution}
     */
    constructor(
        private workflows:WorkflowsService,
        private LWUIRuleEngine:LWUIRuleEngine
    ){}
     /**this method is main function which will be called from outside of the class
     * @return {[cb]}
     */
     execute(eventName, params, service, cb) {
        try {
            if (this._validateParams(params)) {
                this._validateEvent(eventName,(isValidEvent) =>{
                    if (isValidEvent) {
                        var workflow = this._getRules(params.brandDetails, eventName);
                        if (workflow && workflow.length) {
                            this._callUIRule(workflow, params, service, (err, success)=> {
                                if (!err) {
                                    return cb(null, success)
                                } else {
                                    return cb(err, null)
                                }
                            })
                        } else {
                            console.warn("lw-event-executor:Function - execute- No UI Rules are configured in the Brand");
                            return cb(null, true);
                        }
                    } else {
                        console.warn("lw-event-executor:Function - execute- Event occured is not a valid event");
                        return cb(null, true);
                    }
                })
            } else {
                console.log("lw-event-executor:Function - execute - Brandetails is not found.")
                return cb(" lw-event-executor:Function - execute - Parameters sent to event executor are not valid", null);
            }
        } catch (e) {
            console.log("Exception occured in lw-event-executor:Function - execute ", e)
            return cb(null, [])
        }
    }

    /** this method is responsible for validating the sent event name
     * @event  {[type - string]}
     * @return {[type - boolean]}
     */
    _validateEvent(eventName, cb) {
        try {
            this._getEventsList((events) =>{
                if (events && events.length && events.indexOf(eventName) > -1) {
                    return cb(true);
                } else {
                    return cb(false);
                }
            })
        } catch (e) {
            console.log("Exception occured in lw-event-executor:Function - _validateEvent ", e)
            return cb(false);
        }

    }

    /** This method will check if the sent parameters has all the required parameters(brand details, feedDetails) 
        or not
     * @param  {[type-object]}
     * @return {[type]}
     */
    _validateParams(params) {
        try {
            if (params.brandDetails && params._id) {
                return true;
            }
            return false;
        } catch (e) {
            console.log("Exception occured in lw-event-executor:Function - _validateEvent ", e)
            return false;
        }
    }

    /**this method will get all the available events from ltms_events_set collection
     * @return {[type-array]}
     */
    _getEventsList(cb) {
        try {
            var eventList:any = []
            

            this.workflows.getWorkflowDataByType(1).subscribe((response) =>{
                if ((_.get(response, "code")) == 0 && _.hasIn(response,'data.data') && !_.isEmpty(response.data.data)) {
                    _.each(response.data.data, (res:any) =>{
                        if (res.applies_to && res.applies_to.length && res.applies_to.indexOf("UIRule") > -1) {
                            eventList.push(res._id);
                        }
                    });
                } else {
                    eventList = [];
                }
                cb(eventList);
            });
        } catch (e) {
            console.log("Exception occured in lw-event-executor:Function - _getEventsList ", e)
            cb([]);
        }
    }

    /** this method will filter and return rules based on sent event name
     * @brandDetail  {[type - object]}
     * @event  {[type - string]}
     * @return {[type - array]}
     */
    _getRules(brandDetails, event) {
        try {
            var rules:any = [];
            if (brandDetails.hasOwnProperty("ui_rules")) {
                var rules = brandDetails.ui_rules;
                if (rules && rules.length) {
                    rules = _.filter(rules, { "event_name": event, "is_enabled": true });
                    var allWorkflowsRules = _.map(rules, (rule:any)=>rule.workflow);
                    var workflowRules = _.flatten(allWorkflowsRules);
                    if (workflowRules && workflowRules.length) {
                        return workflowRules;
                    } else {
                        return [];
                    }
                }
            }
            return rules
        } catch (e) {
            console.log("Exception occured in lw-event-executor:Function - _getRules ", e)
            return [];
        }
    }

    /**
     * @workflow  {[type-array] - rules that needs to be executed by ui rule engine}
     * @data  {[type-object] - data required for executing ui rule}
     * @cb  {Function} - callback function
     * @return {[type]}
     */
    _callUIRule(workflow, data, service, cb) {
        try {
            this.LWUIRuleEngine.execute(workflow, Helpers.deepClone(data), service, function(err, success) {
                if (!err) {
                    return cb(null, success)
                } else {
                    return cb(err, null)
                }
            })
        } catch (e) {
            console.log("Exception occured in lw-event-executor:Function - _callUIRule ", e)
            return cb(e, null)
        }
    }

    
}